import React from 'react';
import { useTranslation } from 'react-i18next';
import { ratingLinks } from './ratingLinks';
import './RatingLookup.css';

const NOTE_FALLBACK = {
  norwegian: 'Norwegian reviews',
  bordeaux: 'Bordeaux archive',
  critics: 'Critic scores',
  crowd: 'Crowd scores',
};

function RatingLookup({ name, bordeaux = false }) {
  const { t } = useTranslation();
  const links = ratingLinks(name, bordeaux);
  if (links.length === 0) return null;

  return (
    <div className="rating-lookup">
      <span className="rating-lookup-label">
        {t('grapeEscape.ratings.label', 'Look up ratings')}
      </span>
      <ul>
        {links.map(link => (
          <li key={link.id}>
            <a
              href={link.url}
              target="_blank"
              rel="noreferrer"
              title={t(`grapeEscape.ratings.note.${link.note}`, NOTE_FALLBACK[link.note])}
            >
              {link.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default RatingLookup;
